import { AlarmNotificationEndingReasonEnum } from "../../common/enums/AlarmNotificationEndingReasonEnum";
import { RecipientTypeEnum } from "../../common/enums/RecipientTypeEnum";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { IeLynxUser } from "../../common/models/eLynxUser";






export enum AlarmNotificationsType {
    Setpoints = 0,
    Objects = 1,
    Recipients = 2
}




export interface IQueryAlarmNotificationParams {
    startDate: Date;
    endDate: Date;
    filterToGroup: boolean;
}



export interface IAlarmNotificationObjectCountItemModel {
    eLynxObject: IeLynxObject;
    parentObject: IeLynxObject;
    recipientType: RecipientTypeEnum;
    currentTimeframeCount: number;
    previousTimeframeCount: number;

    tagCount?: number;
    setPointCount?: number;
    user?: IeLynxUser;

    color?: string;
    highlight?: boolean;
}

export interface IAlarmNotificationObjectCountModel {

    hasEdit: boolean;
    objectCountItems: IAlarmNotificationObjectCountItemModel[];
}


export interface IAlarmNotificationCountModel {
    alarmTimestamp: Date;
    recipientType: RecipientTypeEnum;
    count: number;
}


export interface IAlarmNotificationDetailRecipientModel {
    alarmID: number;
    recipientID: number;
    recipientType: RecipientTypeEnum
}


export interface IAlarmNotificationDetailModel {
    alarmID: number;
    setPointID: number;
    setPointName: string;
    object: IeLynxObject;
    tags: IeLynxObject[];
    endingReason: AlarmNotificationEndingReasonEnum;
    alarmTimestamp: Date;
    clearTimestamp: Date;
    recipients: IAlarmNotificationDetailRecipientModel[];
}
